import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { populateFreight } from '../../store/ducks/tables/actions';
import { Freights } from '../../store/ducks/tables/types';
import { freightTypeEnum } from './useConfigureFreight';

export interface GetFreightsResponse {
  page: number;
  rows: Freights[];
  totalRecords: number;
  numberCargo?: string;
  status?: string;
  endDate?: string;
  startDate?: string;
}

export default function useGetFreights() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(params: {
    page?: number;
    rowsPerPage?: number;
    status?: string;
    numberCargo?: string;
    startDate?: string;
    endDate?: string;
    freightTypes: freightTypeEnum[] | undefined;
  }): Promise<GetFreightsResponse | undefined> {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/freights', {
        params: {
          page: params.page,
          rowsPerPage: params.rowsPerPage || 20,
          status: params.status === 'Todos' ? null : params.status,
          numberCargo: params.numberCargo,
          startDate: params.startDate,
          endDate: params.endDate,
          types: params.freightTypes,
        },
      });

      if (response.status === 200) {
        dispatch(populateFreight(response.data));
        return response.data;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.operationFailed);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
